import React, { useState, useEffect } from 'react';
import { Mention, MentionsInput } from "react-mentions";
import mentionsInputStyle from "./MentionsStyling/mentionsInputStyle";
import mentionStyle from "./MentionsStyling/mentionStyle";

export interface CommentDataModel {
  id: string | number, 
  display: any
}

interface ICommentMentionsProps {
  data: CommentDataModel[];
  className?: string;
  handleChange?: (e: any) => void;
  trigger?: string;
  onAdd?: (id: any, display?: any) => void;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  ref?: any;
  onFocus?: any;
  onBlur?: any;
}

const CommentMentions = (props: ICommentMentionsProps) => {
  const { handleChange, onAdd, data, className, trigger, value, placeholder, disabled, ref, onBlur, onFocus } = props;
  const [inputValue, setInputValue] = useState(value || '');

  useEffect(() => {
    if (value && inputValue !== value) {
      setInputValue(value);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])


  return (
    <MentionsInput
      value={value}
      onChange={(e => {
        setInputValue(e?.target?.value)
        handleChange && handleChange(e)
      })}
      className={className}
      style={mentionsInputStyle}
      placeholder={placeholder}
      disabled={disabled}
      ref={ref}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      <Mention
        trigger={trigger || "@"}
        data={data}
        style={mentionStyle}
        onAdd={onAdd}
      />
    </MentionsInput>
  )
}

export default CommentMentions